import { reactive, ref, computed, onBeforeMount, onMounted, watch} from '@vue/composition-api'
import store from '@/store'
import * as _ from 'lodash'
import { Document } from '@/logic/document/Document'
import { SCROLL_INTERVAL_DELAY, SCROLL_INTERVAL_MAX_COUNT } from '@/util/constants'
import * as apiPrecedent from '@/api/precedent'
import Vue from 'vue'

export const DocumentList = (props, context) => {
  const {documentLogic, getPrecedentDetail} = Document(props, context)
  const accordionRef = ref(null)
  const router = context.root.$router

  onMounted(() => {
    store.dispatch('precedent/setTab', 2) // 1：検索タブ、2：目次タブ

    if (props.previewBookRevisionId && props.previewBookRevisionId !== 0) {
      // 管理画面からのプレビュー表示
      store.dispatch('precedent/setPreviewBookRevisionId', props.previewBookRevisionId)
      logic.initPreview()
    } else {
      // 通常表示
      store.dispatch('precedent/setPreviewBookRevisionId', 0)
      logic.init()
    }

    documentLogic.init()
  })

  const precedentData = reactive({
    toc: [], // 目次データ
    scrollTopThemeId: 0 // // 目次スクロール位置指定用ThemeId
  })

  // ページ固有のロジック
  const logic = reactive({
    // 管理画面からのプレビューフラグ
    isPreview: computed(() => {
      return (store.state.precedent.previewBookRevisionId !== 0)
    }),

    // 目次情報開閉フラグ
    // テーマIDから目次トグルを開閉した後trueになる
    isTocOpend: false,

    // 初期表示
    init: () => {
      documentLogic.getBooks()

      // 各URLでのアクセス時
      if (props.bookRevisionId) {
        store.dispatch('precedent/clearBook')
        store.dispatch('precedent/clearTheme')
        store.dispatch('precedent/clearDetail')

        store.dispatch('precedent/setBookRevisionId', props.bookRevisionId)
        documentLogic.state.isFirst = false
        documentLogic.state.isRevisionFixed = true
      } else if (props.themeId) {
        store.dispatch('precedent/setBookRevisionId', 0)
        store.dispatch('precedent/clearDetail')
      } else if (props.detailId) {
        store.dispatch('precedent/setBookRevisionId', 0)
        store.dispatch('precedent/setDetailId', props.detailId)
      }

      // storeの情報からURLを変更
      if (router.currentRoute.name === 'PCDocumentList' || router.currentRoute.name === 'SPDocumentList') {
        const routerParams = {}

        if (documentLogic.state.detailId !== 0) {
          if (store.state.common.device === 'sp') {
            routerParams.name = 'SPDocumentListDetail'
          } else {
            routerParams.name = 'PCDocumentListDetail'
          }
          routerParams.params = { detailId: documentLogic.state.detailId }
        } else if (documentLogic.state.themeId !== 0) {
          if (store.state.common.device === 'sp') {
            routerParams.name = 'SPDocumentListTheme'
          } else {
            routerParams.name = 'PCDocumentListTheme'
          }
          routerParams.params = { themeId: documentLogic.state.themeId }
        } else {
          documentLogic.state.isFirst = false
        }

        if (routerParams.name) {
          router.push(routerParams)
        }
      }
    },

    // 管理画面からのプレビュー表示
    initPreview: async() => {
      // 管理システムの書籍プレビューから遷移してきた場合
      // URLからリビジョンID等は変更しない
      documentLogic.state.isFirst = false
      documentLogic.state.isRevisionFixed = true
      documentLogic.getMasterData(store.state.precedent.previewBookRevisionId)

      // 目次データの取得
      logic.updatePreviewToc(store.state.precedent.previewBookRevisionId)
    },

    // ヘッダーセレクタの本の選択
    selectBook: (bookRevisionId) => {
      documentLogic.selectBook(bookRevisionId)
      logic.updateToc(bookRevisionId)
    },

    // テーマ切り替え
    changeTheme: (themeId) => {
      if (!logic.isPreview) {
        store.dispatch('precedent/setThemeId', themeId)
      }

      // テーマデータの取得
      const detailIds = [themeId]
      getPrecedentDetail(detailIds, 'theme')
      
      // テーマ表示の切り替え
      documentLogic.state.isShowResult = true
      documentLogic.state.isShowDetail = false
    },

    changeThemeURL: (themeId) => {
      const routerParams = {params: { themeId }}
      if (documentLogic.state.tab === 2) {
        if (store.state.common.device === 'sp') {
          routerParams.name = 'SPDocumentListTheme'
        } else {
          routerParams.name = 'PCDocumentListTheme'
        }
      }

      if (router.currentRoute.name === routerParams.name && Number(router.currentRoute.params.themeId) === routerParams.params.themeId) {
        // 現在のURLと遷移先のURLが同じ場合は遷移しない
        // SPの場合、表示エリアを切り替える
        if (store.state.common.device === 'sp') {
          documentLogic.state.isShowResult = true
          documentLogic.state.isShowDetail = false
        }
      } else {
        router.push(routerParams)
      }
    },

    scrollToc: () => {
      precedentData.scrollTopThemeId = documentLogic.state.themeId

      if (precedentData.scrollTopThemeId !== 0) {
        // Vue.nextTick()の場合、対象htmlIdを取得できない場合がある。
        // ツリー描画に時間がかかるのではと思われる。
        // そのため、setInterval()でスクロール先要素を取得するまでループする
        let count = 0
        const intervalId = setInterval(() => {
          const htmlId = 'toc_' + precedentData.scrollTopThemeId
          const target = document.getElementById(htmlId)
          if (target) {
            const targetRect = target.getBoundingClientRect()
            let scrollArea = null
            if (store.state.common.device === 'sp') {
              scrollArea = document.getElementById('scroll-area')
            } else {
              scrollArea = document.getElementById('printToc')
            }
            
            if (scrollArea) {
              const areaRect = scrollArea.getBoundingClientRect()
              const scrollY = scrollArea.scrollTop + targetRect.top - areaRect.top - 100
              scrollArea.scrollTop = scrollY
              // 保持していた値をクリア
              precedentData.scrollTopThemeId = 0
              clearInterval(intervalId)
            }
          }
          count++
          if (count >= SCROLL_INTERVAL_MAX_COUNT) {
            clearInterval(intervalId)
          }
        }, SCROLL_INTERVAL_DELAY)
      }
    },

    updateToc: async(bookRevisionId = documentLogic.state.bookRevisionId) => {
      documentLogic.state.isTocLoading = true

      const result = _.find(store.state.precedent.tocList, a => a.bookRevisionId === bookRevisionId)

      if (result) {
        precedentData.toc = result.toc
        documentLogic.state.isTocLoading = false

        // 目次エリアの開閉
        logic.openToggle()

      } else {
        // リビジョンIDに一致する目次データがない場合、リビジョンID指定で目次情報を追加読み込み
        await store.dispatch('precedent/addTOCList', store.state.precedent.bookRevisionId)

        const result2 = _.find(store.state.precedent.tocList, a => a.bookRevisionId === bookRevisionId)
        if (result2) {
          precedentData.toc = result2.toc
          documentLogic.state.isTocLoading = false

          // 目次エリアの開閉
          logic.openToggle()
        }
      }
    },

    updatePreviewToc: async(bookRevisionId) => {
      documentLogic.state.isTocLoading = true

      const params = {
        book_revision_id: bookRevisionId
      }
      return apiPrecedent.getTOC(params)
        .then(response => {
          const { data } = response
          if (data.status === 0) {
            store.dispatch('precedent/setBookName', data.title)

            precedentData.toc = data.list
            documentLogic.state.isTocLoading = false
          } else {
            // エラー処理
            const payload = {
              title: 'エラー',
              text: data.error_message
            }
            store.dispatch('common/showNotice', payload)
          }
        })
    },

    // 指定されているthemeIDに一致するトグルとその親たちを開く
    openToggle: () => {
      logic.isTocOpend = false
      const result = logic.findOpenThemeIds(precedentData.toc, documentLogic.state.themeId)
      // 目次トグルの開閉処理
      logic.restoreOpenItems(result)
    },

    // targetIdに一致する目次とその親の目次のidを計算
    findOpenThemeIds: (data, targetId) => {
      let result = []
     
      const traverse = (arr, parents) => {
        _.flatMapDeep(arr, (item) => {
          if (item.id === targetId) {
            result = [...parents, item.id]
            return false // ループを終了させるためにfalseを返す
          }
          if (_.isArray(item.children) && item.children.length > 0) {
            return traverse(item.children, [...parents, item.id])
          }
        })
      }
      traverse(data, [])
      return result
    },

    // 指定されたidの目次を開く
    restoreOpenItems(targetIds) {
      precedentData.toc.forEach(item => {
        if (targetIds.includes(item.id)) {
          Vue.set(item, 'isOpen', true)
          if (item.id === documentLogic.state.themeId) logic.isTocOpend = true
        } else {
          // あえて閉じることはしない
          // item.isOpen = false
        }
        if (item.children) {
          logic.restoreOpenItemsRecursive(item.children, targetIds)
        }
      })
    },
    restoreOpenItemsRecursive(items, targetIds) {
      items.forEach(item => {
        if (targetIds.includes(item.id)) {
          Vue.set(item, 'isOpen', true)
          if (item.id === documentLogic.state.themeId) logic.isTocOpend = true
        } else {
          // あえて閉じることはしない
          // item.isOpen = false
        }
        if (item.children) {
          logic.restoreOpenItemsRecursive(item.children, targetIds)
        }
      })
    },
    openScrollToc: () => {
      // カレントの目次情報トグルを開く
      logic.openToggle()
    }
  })

  const operationSizeChange = reactive({
    // 目次エリアを広げる(PC)
    fullSizeSummary: () => {
      documentLogic.state.isFullSummary = true
    },
    // 目次エリアを通常サイズにする(PC)
    normalSizeSummary: () => {
      documentLogic.state.isFullSummary = false
    },
    // 目次情報を見る(SP)
    showSummary: () => {
      documentLogic.state.isShowDetail = false
      documentLogic.state.isShowResult = false

      // 目次エリアのスクロール
      precedentData.scrollTopThemeId = documentLogic.state.themeId
      logic.scrollToc()
    },
    // 一覧情報を見る(SP)
    showList: () => {
      logic.changeThemeURL(documentLogic.state.themeId)
      documentLogic.state.isShowResult = true
      documentLogic.state.isShowDetail = false
    }
  })

  // URLを監視する
  watch(() => props.detailId, (newVal, oldVal) => {
    if (newVal) {
      if (!logic.isPreview) {
        store.dispatch('precedent/setDetailId', newVal)
      }

      _.each(documentLogic.data.list, (value, index) => {
        // 一覧のカレント付け替え
        if (value.id === newVal) {
          documentLogic.data.list[index].isCurrent = true
        } else if (value.id === oldVal) {
          documentLogic.data.list[index].isCurrent = false
        }

        // 関連要旨のカレント付け替え
        _.each(value.relatedItems, (relatedItem, index2) => {
          if (relatedItem.id === newVal) {
            documentLogic.data.list[index].relatedItems[index2].isCurrent = true
          } else if (relatedItem.id === oldVal) {
            documentLogic.data.list[index].relatedItems[index2].isCurrent = false
          }
        })
        // 参照のカレント付け替え
        _.each(value.referenceItems, (referenceItem, index3) => {
          if (referenceItem.id === newVal) {
            documentLogic.data.list[index].referenceItems[index3].isCurrent = true
          } else if (referenceItem.id === oldVal) {
            documentLogic.data.list[index].referenceItems[index3].isCurrent = false
          }
        })
      })
     
      documentLogic.getDetaiPage(newVal)
      documentLogic.state.isShowDetail = true
    }
  })

  // themeIDの監視
  watch(() => props.themeId, (newVal, oldVal) => {
    if (newVal) {
      logic.changeTheme(newVal)
      logic.openToggle()
    }
  })

  // リビジョンIDが確定したら目次情報更新処理。
  // 書籍セレクタ変更時はセレクタ側で更新するのでリビジョンIDの監視は行わない
  watch(() => documentLogic.state.isRevisionFixed, (newVal) => {
    if (newVal) {
      if (!logic.isPreview) { // プレビュー時は目次情報を更新しない
        logic.updateToc()
      }
    }
  })

  // 書籍の切り替えを監視
  watch(() => documentLogic.state.isBookChanged, (newVal, oldVal) => {
    if (newVal) {
      documentLogic.state.isBookChanged = false
    }
  })

  // 書籍データの読み込みが完了し、詳細APIのレスポンスが帰ってきたら書籍セレクタを更新
  watch(() => (!documentLogic.state.isBooksLoading && !documentLogic.state.isFirst), (newVal) => {
    if (newVal) {
      if (!logic.isPreview) {
        documentLogic.changeBook()
      }
    }
  })

  watch(() => documentLogic.state.isFirst, (newVal) => {
    if (newVal === false) {
      logic.openToggle()
    }
  })

  // 目次情報の開閉処理が終わったタイミングでスクロール
  watch(() => logic.isTocOpend, (newVal) => {
    if (newVal) {
      // カレントの目次情報までスクロール
      precedentData.scrollTopThemeId = documentLogic.state.themeId
      logic.scrollToc()
    }
  })

  return {
    documentLogic,
    logic,
    precedentData,
    operationSizeChange,
    accordionRef
  }
}
